
import { useState } from "react";
import { format } from "date-fns";

import processLogApi from "../../api/processLogApi";
import useMount from '../../hooks/useMount';
import { getLabel } from "../../tools/Dictionary";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import LoadingComponent from "../Commons/LoadingComponent";
import ReviewComponent from "../Commons/ReviewComponent";

const ProcessLogModal = (props) => {

  //Props
  //const IsDesktop = props.IsDesktop;
  //const Access = props.Access;
  const Id = props.Id;
  const OnCloseModal = props.OnCloseModal;
  const LoadData = props.LoadData;

  //State
  const [processLog, setProcessLog] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [isUpdate] = useState(Id && Id != 0);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });



  useMount(() =>
  {
    loadData();
  }, []);


  const loadData = async() => {

    if (isUpdate){

      try{

        setLoading(true);

        let response = await processLogApi.getProcessLog(Id);

        if (!response.Success)
        {

          let error = new Error()
          error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

          throw error;

        }


        setProcessLog(response.Data);
        setLoading(false);

      }catch(err){


        setAlert({
          Title: getLabel("App", "Error"),
          Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: onFatalError,
          Display: true
        });

      }

    }else{
      setLoading(false);
    }

  };

  const onFatalError = async() => {

    setAlert(alert => ({ ...alert, Display: false }));

    await LoadData();

    setLoading(false);

    OnCloseModal();

  };


  if (!processLog) return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ProcessLogPage", "Process Logs")}
        </div>
        <div className="page_modal_body_cont" />
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{marginBottom: "10px"}}>
          {getLabel("ProcessLogPage", "Process Logs")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_ProcessLog", "process")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={processLog.process.code || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessLogPage", "Brand")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={processLog.product.brand.code || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessLogPage", "Product Model")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={processLog.product.code || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessLogPage", "User Email")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={processLog.user.email || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessLogPage", "User Name")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={processLog.user.firstName + " " + processLog.user.lastName || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessLogPage", "Log Date")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className="page_text_input"
                value={format(processLog.createdAt, 'yyyy-MM-dd HH:mm') || ""}
                type="text"
                style={{ width: "100%" }}
                readOnly={true}
              />
            </div>
          </div>
          {processLog.review &&
            <div className="page_modal_body_row">
              <div className="page_modal_body_col_title">
                {getLabel("ProcessLogPage", "Review")}
              </div>
              <div className="page_modal_body_col_value" style={{ width: "400px" }} >
                <ReviewComponent 
                  Rating={processLog.review.rating}
                  ReadOnly={true}
                />
                <textarea
                  className={"page_textarea_input "}
                  rows={10}
                  value={processLog.review.comment || ""}
                  type="text"
                  style={{ width: "100%" }}
                  readOnly={true}
                />
              </div>
            </div>
          }
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title" style={{width: "100%", justifyContent: "center"}}>
              Path
            </div>
          </div>
          <div className="processlog_path_cont">
            {processLog.path.map((p, pIndex) => (
              <div className="processlog_path_step" key={pIndex}>
                {p.processStepTitle}
                {p.component.filter(c => c.isVariable).map((c, cIndex) => (
                  <div className="processlog_path_component_cont" key={cIndex}>
                    <div className="processlog_path_component_title">
                      {c.name}
                    </div>
                    <div className="processlog_path_component_value">
                      {c.value}
                    </div>
                  </div>
                ))}

              </div>
            ))}
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );
  

};

export default ProcessLogModal;